"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTimeoutStatus = exports.isSuccessStatus = exports.successStatusCodesWithoutDataAndDatum = exports.successStatusCodesWithDataOrDatum = exports.errorTimeoutStatusCode = void 0;
var errorTimeoutStatusCode = 408;
exports.errorTimeoutStatusCode = errorTimeoutStatusCode;
var successStatusCodesWithDataOrDatum = [200, 201, 202, 203, 205, 206, 207, 208, 210, 226];
exports.successStatusCodesWithDataOrDatum = successStatusCodesWithDataOrDatum;
var successStatusCodesWithoutDataAndDatum = [204];
exports.successStatusCodesWithoutDataAndDatum = successStatusCodesWithoutDataAndDatum;

var isSuccessStatus = function isSuccessStatus(status) {
  return successStatusCodesWithDataOrDatum.includes(status) || successStatusCodesWithoutDataAndDatum.includes(status);
};

exports.isSuccessStatus = isSuccessStatus;

var isTimeoutStatus = function isTimeoutStatus(status) {
  return status === errorTimeoutStatusCode;
};

exports.isTimeoutStatus = isTimeoutStatus;